const ROOT = '/shop/battery';

export const PUBLIC_BATTERY_ECOMM_ROUTES = {
  LANDING: ROOT,
  QUOTE: `${ROOT}/quote`,
  CONFIRMATION: `${ROOT}/confirmation`,
  CONTACT: `${ROOT}/contact`,
  OUT_OF_SERVICE: `${ROOT}/out-of-service`,
  ADD_A_BATTERY: '/add-a-battery',
  ADD_A_BATTERY_LEAD_FORM: '/add-a-battery#lead-form',
};

export function isPublicBatteryRoute(pathname: string): boolean {
  return pathname === ROOT || pathname.startsWith(`${ROOT}/`);
}
